export const UsageGroups = {
  PDF: 'pdf',
  WEIGHTING: 'weighting',
};
